module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!./member-payment-schedule-history.ts"));
	}, "forms/member-payment-schedule-history/member-payment-schedule-history");
}